import { CallOverrides } from "ethers";
      /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type CheckpointsContractFunctions1 =
  | []
  | [CheckpointsContractFunctions]
  | [CheckpointsContractFunctions, CheckpointsContractEvents];
export type SWEvent = {
  event: CheckpointsContractEventType;
  args: any;
}[];

export interface CheckpointsContractFunctions {
  checkpoints: (
    overrides?: CallOverrides
  ) => Promise<{
    competition: string;
    metadataUri: string;
    startDate: number;
    endDate: number;
    skill1: number;
    skill2: number;
    skill3: number;
    role: number;
  }>;
  create: (
    metadata: string,
    startDate: number,
    endDate: number,
    skills: string,
    role: number,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<CheckpointsContractEvents>}>;
  getCheckpointsPerCompetition: (competition: string, overrides?: CallOverrides) => Promise<number[]>;
  hasAParticipantPassedTheCheckpoint: (
    checkpointID: number,
    member: string,
    overrides?: CallOverrides
  ) => Promise<boolean>;
  hasSkill: (checkpointID: number, role: number, skill: number, overrides?: CallOverrides) => Promise<boolean>;
  pass: (
    checkpointID: number,
    participant: string,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<CheckpointsContractEvents>}>;
}
export interface CheckpointsContractEvents {
  events: SWEvent;
}

export enum CheckpointsContractEventType {
  CheckpointCreated = "CheckpointCreated",
  CheckpointPassed = "CheckpointPassed"
}
